import InfoIcon from '@mui/icons-material/Info';
import { IconButton } from '@mui/material';

import LightTooltip from './LightTooltip';

interface Props {
	employees: Array<{ employeeId: number; name: string }>;
	className?: string;
}

const ApprovalLevelTooltipIcon = ({ employees }: Props) => {
	if (!employees) {
		return <></>;
	}
	return (
		<LightTooltip
			title={
				<div
					style={{
						whiteSpace: 'pre-line',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'flex-start',
						justifyContent: 'space-between',
						padding: '8px',
					}}
				>
					<div className="text-sm font-medium text-[#193CB9] mb-2">Colaboradores</div>
					<div className="flex flex-col gap-2">
						{employees.map(employee => (
							<div key={employee.employeeId}>{employee.name}</div>
						))}
					</div>
				</div>
			}
			placement="top"
			arrow
		>
			<IconButton
				sx={{ height: '2rem', width: '2rem' }}
				aria-label="information"
				size="small"
				color="primary"
			>
				<InfoIcon fontSize="inherit" />
			</IconButton>
		</LightTooltip>
	);
};

export default ApprovalLevelTooltipIcon;
